import XHR from "@/request/http";
const $h = new XHR();
// url
const url = {
  list: "/admin/v1/agents/list",
  page: "/admin/v1/agents/page",
  save: "/admin/v1/agents/save",
  del: "/admin/v1/agents/delete",
  get: "/admin/v1/agents/detail",
  category: "/admin/v1/agents/category",
  categorySave: "/admin/v1/agents/category/save",
  categoryDel: "/admin/v1/agents/category/delete",
  categoryGet: "/admin/v1/agents/category/detail",
};

export async function page(data) {
  return $h.request(url.page, data, "GET");
}

export async function list(data) {
  return $h.request(url.list, data, "GET");
}

export async function save(data) {
  return $h.request(url.save, data, "POST");
}

export async function del(data) {
  return $h.request(url.del + "/" + data.id, {}, "POST");
}

export async function get(data) {
  return $h.request(url.get + "/" + data.id, {}, "GET");
}

export async function category() {
  return $h.request(url.category, {}, "GET");
}

export async function categorySave(data) {
  return $h.request(url.categorySave, data, "POST");
}

export async function categoryDel(data) {
  return $h.request(url.categoryDel + "/" + data.id, {}, "POST");
}

export async function categoryGet(data) {
  return $h.request(url.categoryGet + "/" + data.id, {}, "GET");
}
